module.exports = __webpack_public_path__ + "img/Rüdersdorf.3b1cdb22.svg";